import { render, staticRenderFns } from "./UserSensors.vue?vue&type=template&id=01232350&"
import script from "./UserSensors.vue?vue&type=script&lang=js&"
export * from "./UserSensors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports